import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogsType } from "../../store/catalog/actions";
export var GetCatalogsType = function (trigger, enable, page, limit, type) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalogsType: (_a = state.Catalog.responseGetCatalogsType) === null || _a === void 0 ? void 0 : _a.data,
            loadingGetCatalogsType: state.Catalog.loadingGetCatalogsType,
            errorGetCatalogsType: state.Catalog.errorGetCatalogsType,
        });
    }), responseGetCatalogsType = _a.responseGetCatalogsType, loadingGetCatalogsType = _a.loadingGetCatalogsType, errorGetCatalogsType = _a.errorGetCatalogsType;
    useEffect(function () {
        if (trigger) {
            dispatch(getCatalogsType({
                enable: enable,
                page: page,
                limit: limit,
                type: type,
            }));
        }
    }, [trigger, enable, page, limit, type]);
    return {
        responseGetCatalogsType: responseGetCatalogsType,
        loadingGetCatalogsType: loadingGetCatalogsType,
        errorGetCatalogsType: errorGetCatalogsType,
    };
};
